import { createAsyncThunk } from '@reduxjs/toolkit';
import webMetricsService from '../../services/webMatrix';

const getWebMatrixFalse = createAsyncThunk(
    'webMatrix/getWebMatrixFalse',
    async (payload, ThunkAPI) => {
        try{
            const response = await webMetricsService.getWebMatrixDataFalse(
                payload.companyId,
                payload.startRange, 
                payload.endRange
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);
const getWebMatrixTrue = createAsyncThunk(
    'webMatrix/getWebMatrixTrue',
    async (payload, ThunkAPI) => {
        try{
            const response = await webMetricsService.getWebMatrixDataTrue(
                payload.companyId,
                payload.startRange, 
                payload.endRange
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getQualityVisits = createAsyncThunk(
    'webMatrix/getQualityVisits',
    async (payload, ThunkAPI) => {
        try{
            const response = await webMetricsService.getQualityVisits(
                payload.companyId,
                payload.startRange, 
                payload.endRange
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getWebMatrixPatientFalse = createAsyncThunk(
    'webMatrix/getWebMatrixPatientFalse',
    async (payload, ThunkAPI) => {
        try{
            const response = await webMetricsService.getWebMatrixPatientFalse(
                payload.companyId,
                payload.startRange, 
                payload.endRange
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getTopWebsites = createAsyncThunk(
    'webMatrix/getTopWebsites',
    async (payload, ThunkAPI) => {
        try{
            const response = await webMetricsService.getTopWebsites(
                payload.companyId,
                payload.startRange, 
                payload.endRange
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getWebMatrixPatientCount = createAsyncThunk(
    'webMatrix/getWebMatrixPatientCount',
    async (payload, ThunkAPI) => {
        try{
            const response = await webMetricsService.getWebMatrixPatientCount(
                payload.companyId,
                payload.startRange, 
                payload.endRange
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getWebMatrixPatientAnalysisSummary = createAsyncThunk(
    'webMetrics/getWebMatrixPatientAnalysisSummary',
    async (payload, ThunkAPI) => {
        try{
            const response = await webMetricsService.getWebMatrixPatientAnalysisSummary(
                payload.companyId,
                payload.startRange, 
                payload.endRange,
                payload.page_no,
                payload.page_size
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getWebMatrixCostDataFalse = createAsyncThunk(
    'webMatrix/getWebMatrixCostDataFalse',
    async (payload, ThunkAPI) => {
        try{
            const response = await webMetricsService.getWebMatrixCostDataFalse(
                payload.companyId,
                payload.startRange, 
                payload.endRange
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);
const getEngagementRateDataFalse = createAsyncThunk(
    'webMatrix/getEngagementRateDataFalse',
    async (payload, ThunkAPI) => {
        try{
            const response = await webMetricsService.getEngagementRateDataFalse(
                payload.companyId,
                payload.startRange, 
                payload.endRange,
                payload.remove_blank,
                payload.trigger_name
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getWebMatrixGeographyDataFalse = createAsyncThunk(
    'webMatrix/getWebMatrixGeographyDataFalse',
    async (payload, ThunkAPI) => {
        try{
            const response = await webMetricsService.getWebMatrixGeographyDataFalse(
                payload.companyId,
                payload.startRange, 
                payload.endRange
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getWebMatrixMultiUsageFalse = createAsyncThunk(
    'webMatrix/getWebMatrixMultiUsageFalse',
    async (payload, ThunkAPI) => {
        try{
            const response = await webMetricsService.getWebMatrixMultiUsageFalse(
                payload.companyId,
                payload.startRange, 
                payload.endRange
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);
export {
    getWebMatrixFalse,
    getWebMatrixTrue,
    getQualityVisits,
    getWebMatrixPatientFalse,
    getTopWebsites,
    getWebMatrixPatientCount,
    getWebMatrixPatientAnalysisSummary,
    getWebMatrixCostDataFalse,
    getEngagementRateDataFalse,
    getWebMatrixGeographyDataFalse,
    getWebMatrixMultiUsageFalse
};